import { render, staticRenderFns } from "./setting-ap-prompt-student.vue?vue&type=template&id=0fd21800&scoped=true"
import script from "./setting-ap-prompt-student.vue?vue&type=script&lang=js"
export * from "./setting-ap-prompt-student.vue?vue&type=script&lang=js"
import style0 from "./setting-ap-prompt-student.vue?vue&type=style&index=0&id=0fd21800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd21800",
  null
  
)

export default component.exports